import { render, staticRenderFns } from "./NewUsersTable.vue?vue&type=template&id=e0505ede&scoped=true&"
import script from "./NewUsersTable.vue?vue&type=script&lang=js&"
export * from "./NewUsersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0505ede",
  null
  
)

export default component.exports